import { elementScrollIntoView } from 'seamless-scroll-polyfill';

export function scrollSmoothElement(element) {
  if(!isScrollBehavior()) {
    elementScrollIntoView(element, {behavior: 'smooth', block: 'center'});
  }
}

const isScrollBehavior = () => "scrollBehavior" in window.document.documentElement.style;
